export const Label = ({ label, type }) => (
  <div className="flex gap-x-4 items-center">
    <p>{label}</p>
    <span className="text-xs font-semibold font-mono">{type}</span>
  </div>
);
